module.exports = __webpack_public_path__ + "img/equipment.eab82b00.png";